// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qd-0";